export default {"src":"/_next/static/media/whiskyExperts.84c41943.svg","height":40,"width":195,"blurWidth":0,"blurHeight":0};